import { styled } from '@mui/material/styles';
import useMeasure from 'react-use-measure';
import { StickyBorderBox } from '../Common/StickyBorderBox';

const DetailsPanelRoot = styled('div')(() => ({}));

const DetailsPanelContent = styled('div')(({ theme }) => ({
  background: theme.palette.background.paper,
  height: '100%',
  boxSizing: 'border-box',
  padding: theme.spacing(10, 30),
}));

const BorderRoot = styled('div')({
  position: 'absolute',
  left: 0,
  right: 0,
  zIndex: 99999,
  pointerEvents: 'none',
});

type DetailsPanelProps = {
  children: React.ReactNode;
};

export const DetailsPanel = ({ children }: DetailsPanelProps) => {
  const [root, rootBounds] = useMeasure();

  // ### To improve for now there are no case that we need this (details panel larger then row)
  // const apiRef = useGridApiContext();
  // const dimensions = useGridSelector(apiRef, gridDimensionsSelector);

  // useEffect(() => {
  //   if (dimensions.rowWidth < rootBounds.width && dimensions.isReady) {
  //     apiRef.current.setColumnWidth('filler', rootBounds.width - (dimensions.rowWidth - 100));
  //   }
  //   return () => {
  //     if (apiRef.current.getExpandedDetailPanels().length === 0) {
  //       apiRef.current.setColumnWidth('filler', 100);
  //     }
  //   };
  // }, [dimensions, rootBounds]);

  return (
    <DetailsPanelRoot ref={root}>
      <BorderRoot>
        <StickyBorderBox height={rootBounds.height} />
      </BorderRoot>
      <DetailsPanelContent>{children}</DetailsPanelContent>
    </DetailsPanelRoot>
  );
};
